import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import { API_URL } from '../../Constants';
import { axiosClient } from '../AxiosClient';

let apiUrl = API_URL;


const useStyles = makeStyles((theme) => ({
    popup: {
        width: '500px'
    }
}));



export default function FormDialog(props) {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();

  const updateNovedadSiigoComment = (novedadSiigoUuid) => {
    let comments = document.getElementById("comment-" + novedadSiigoUuid).value;
    let novedadSiigoRequest = {comments: comments}
    axiosClient.patch(`/v1/failed-eliminated-quota/${novedadSiigoUuid}`, novedadSiigoRequest, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    })
    .then(response => {
        if (response.status === 200) {
            setOpen(false);
            props.setComment(comments);
        }
    })
    .catch(error => {
        console.log('Hubo un problema con la petición Axios: ' + error.message);
    });
};

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}>
        <EditIcon></EditIcon>
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Comentarios</DialogTitle>
        <DialogContent>
            
           <TextField
          id={"comment-" + props.novedadSiigoUuid}
          multiline
          rows={4}
          defaultValue={props.novedadSiigoComment}
        />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={() => updateNovedadSiigoComment(props.novedadSiigoUuid)}>Guardar</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
